import firebase from 'firebase/compat/app';
import { db } from './config';

export interface AthleteProfile {
  slug: string;
  age?: string;
  pictureUrl?: string;
  animal?: string;        // "If your climbing style were an animal…"
  ritual?: string;        // "Pre-competition rituals or superstitions"
  hypeSong?: string;      // "Ultimate hype song"
  proudMoment?: string;   // "Proudest or funniest climbing moment"
  climbWith?: string;     // "Climb with any person in the world"
  hiddenTalent?: string;  // "Hidden talent"
  cheatMeal?: string;     // "Post-competition cheat meal"
}

const COLLECTION = 'athlete-profiles';

function docRef(slug: string): firebase.firestore.DocumentReference {
  return db.collection(COLLECTION).doc(slug);
}

export async function getAthleteProfile(slug: string): Promise<AthleteProfile | null> {
  const snap = await docRef(slug).get();
  if (!snap.exists) return null;
  return snap.data() as AthleteProfile;
}

export async function getAllAthleteProfiles(): Promise<Record<string, AthleteProfile>> {
  const snap = await db.collection(COLLECTION).get();
  const result: Record<string, AthleteProfile> = {};
  snap.forEach(doc => { result[doc.id] = doc.data() as AthleteProfile; });
  return result;
}
